module.exports = "pegasus/assets/email1-company-logo1.png";